const validateInputEmail = (email: string) => {
  if (!email) {
    return true;
  }
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};
export default validateInputEmail;
